import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BrandMark from "@/components/BrandMark";

export default function PublicFooter() {
  const { t } = useTranslation();
  return (
    <footer data-testid="public-footer" className="bg-secondary text-secondary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <BrandMark size={44} />
            <div className="leading-none">
              <div className="font-heading font-black text-2xl tracking-tight text-white">
                Safeway<span className="text-primary">·</span>Finland
              </div>
              <div className="mt-2 text-[10px] font-heading font-black uppercase tracking-[0.22em] text-white/60">
                {t("brand.tagline")}
              </div>
            </div>
          </div>
          <p className="mt-5 text-sm text-secondary-foreground/70 max-w-md leading-relaxed">{t("footer.blurb")}</p>
          <p className="mt-6 overline text-primary/80">Est. Helsinki · 2018</p>
        </div>
        <div>
          <div className="overline text-primary/70 mb-4">{t("footer.platform")}</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/services" className="hover:text-primary">{t("footer.services")}</Link></li>
            <li><Link to="/register" className="hover:text-primary">{t("footer.beSupplier")}</Link></li>
            <li><Link to="/register" className="hover:text-primary">{t("footer.beBuyer")}</Link></li>
            <li><Link to="/contact" className="hover:text-primary">{t("footer.contact")}</Link></li>
          </ul>
        </div>
        <div>
          <div className="overline text-primary/70 mb-4">{t("footer.contactCol")}</div>
          <ul className="space-y-2 text-sm text-secondary-foreground/80">
            <li>info@safewayfinland.fi</li>
            <li>{t("footer.office")}</li>
            <li>{t("footer.hubs")}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-secondary-foreground/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between text-xs text-secondary-foreground/60">
          <div>{t("footer.rights")}</div>
          <div>{t("footer.tagline")}</div>
        </div>
      </div>
    </footer>
  );
}
